import React from 'react'

export interface ConstraintPinProps {
  x: number
  rowTop: number
}

/** 10 px pin glyph marking a non-ASAP constraint at the bar's start. Spec B §8.4. */
const ConstraintPin: React.FC<ConstraintPinProps> = ({ x, rowTop }) => (
  <g data-constraint-pin transform={`translate(${x - 6},${rowTop + 4})`} className="pointer-events-none">
    <path d="M5 0C2.24 0 0 2.24 0 5c0 3.75 5 8 5 8s5-4.25 5-8c0-2.76-2.24-5-5-5z" className="fill-muted-foreground" />
    <circle cx={5} cy={5} r={1.6} className="fill-background" />
  </g>
)

export default ConstraintPin
